import React, { ReactElement } from 'react';
import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import { useLocation, useParams } from 'react-router';
import routes from '../../routing/routes';
import GlobalErrors from '../../module/GlobalErrors';
import SecuredPage from '../../module/SecuredPage';
import PageHeadingWithBackButton from '../../module/PageHeadingWithBackButton';
import Layout from '../Layout';
import { NavrhUzneseniaVlady } from '../../module/SprievodnyDokument/CreateFromForm';
import {
  NavrhUzneseniaVladyFormData,
} from '../../model/sprievodnyDokument/navrhUzneseniaVlady/NavrhUzneseniaVladyFormData';
import {
  createNavrhUzneseniaVladyClient,
} from '../../client/external/evidencnaaplikacia/navrhUzneseniaVladyClient';
import LegislativnyMaterialDetail
  from '../../model/legislativnyMaterial/LegislativnyMaterialDetail';
import useLegMaterialDetailPozicia from '../../hooks/useLegMaterialDetailPozicia';
import PracovnyKrokEnum from '../../model/pracovnyKrok/PracovnyKrokEnum';
import isPredbeznaInformacia from '../../function/isPredbeznaInformacia';
import SuccessMessages from '../../module/SuccessMessages';
import { useClient } from '../../context/ClientStatusContext';

const getInitData = (material: LegislativnyMaterialDetail, nazovPozicie: string): NavrhUzneseniaVladyFormData => ({
  isUznesenie: false,
  nazovMaterialu: `{"blocks":[{"key":"15eo1","text":"${material?.nazov}","type":"unstyled",`
    + '"depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
  cisloMaterialu: undefined,
  predkladatel: nazovPozicie,
  castList: [],
  naVedomie: undefined,
  vykonaju: undefined,
});

const NavrhUzneseniaVladyCreatePage = (): ReactElement => {
  const location = useLocation();
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();

  const {
    nazovPozicie,
    materialDetail,
    materialStatus,
  } = useLegMaterialDetailPozicia(type, year, index, PracovnyKrokEnum.SPRIEVODNY_DOKUMENT_FUNCTION);

  const {
    wrapClient: createNavrhUzneseniaVlady,
  } = useClient(createNavrhUzneseniaVladyClient);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: isPredbeznaInformacia(type) ? 'Predbežné informácie' : 'Legislatívne procesy',
          to: isPredbeznaInformacia(type) ? routes.procesy.predbeznaInformacia.list : routes.procesy.list,
        },
        {
          heading: `${type}/${year}/${index}`,
          to: routes.procesy.detail.withParams(type, year, index),
        },
        {
          heading: 'Sprievodná dokumentácia',
          to: routes.procesy.detail.sprievodneDokumenty.edit.withParams(type, year, index),
        },
        {
          heading: 'Návrh uznesenia vlády Slovenskej republiky',
          to: location.pathname,
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={materialStatus.loading}>
        <SecuredPage
          hasOpravneniePracovneKroky={materialDetail?.hasOpravnenieSprievodneDokumenty}
          requestStatus={materialStatus.responseCode}
        >
          <>
            <SuccessMessages />
            {materialDetail && (
            <>
              <PageHeadingWithBackButton
                headingCaption={`Legislatívny proces ${materialDetail.cisloLegislativnehoMaterialu}`}
                heading="Návrh uznesenia vlády Slovenskej republiky"
                withBackLink
              />
              <NavrhUzneseniaVlady
                material={materialDetail}
                initialData={getInitData(materialDetail, nazovPozicie)}
                onSubmit={createNavrhUzneseniaVlady}
              />
            </>
            )}
          </>
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default NavrhUzneseniaVladyCreatePage;
